module.exports = __webpack_public_path__ + "img/avid-logo.948c8db7.png";